<template>
    <div id="app">
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div style="width: 90%;margin: 20px auto;">
            <div class="wrap" style="text-align: center;">
                <p class="footer_font">邮箱：chichengtong01@163.com</p>
                    <div style="margin: auto;" class="footer_font">
                        ©福建驰城通科技有限公司版权所有 &nbsp;&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35012102500798" style="text-decoration: none;color:black"><img src="../assets/gongan.png"/>闽公网安备 35012102500798号</a>
                        &nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" href="http://beian.miit.gov.cn" style="text-decoration: none;color:black">闽ICP备2023004404号-2</a>
                        
                    </div>
            </div>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                isMouseInPop:false,
                showPop : false,
                selectMenu:'',
                activeIndex: '1',
                company:{
                    // qrcode: require("../../static/other/公众号二维码.jpg"),
                },
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页'
            };
        },
        watch:{
            activeIndex(val){
                // eslint-disable-next-line no-console
                console.log('val..',val);
            },
        },
        mounted(){
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('click', this.clickWindow)
        },
        methods: {
            clickWindow(e){
                if(!this.isMouseInPop && this.showPop){
                    this.showPop = false
                }
            },
            handleSelect(key) {
                this.selectMenu = key
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2':
                        setTimeout(() => {
                            this.showPop = true
                        }, 0);
                        break;
                    case '2-1':
                        this.$router.push({name: "Ecommerce"});
                        this.showPop = false
                        break;
                        case '2-2':
                            this.$router.push({name: "OnlineCar"});
                            this.showPop = false
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        break;
                    case '5':
                        this.$router.push({name: "AboutUs"});
                        // window.location.hash = "#关于我们";
                        break;
                    case '6':
                        this.$router.push({name: "ContactUs"});
                        // window.location.hash = "#关于我们";
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2-1':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品微观";
                        this.currentMenu='首页';
                        break;
                    case '2-2':
                        this.$router.push({name: "Fruit"});
                        this.currentMenu='生鲜果蔬';
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        this.currentMenu='首页';
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        this.currentMenu='首页';
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        this.currentMenu='首页';
                        break;
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                    this.$refs.btn.style.display = 'block';
                }else{
                    this.$refs.btn.style.display = 'none'
                }
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                window.open('https://admin.fastice-tech.com/login')
            },
            register(){
                window.open('https://admin.fastice-tech.com/registe')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
    }
</script>

<style scoped lang="scss">
    ::v-deep .el-icon-arrow-down{
        display: none;
    }
   
    .pop-wrap{
        background: white;
        width: 120px;
        // height: 100px;
        margin-left: 80px;
        padding: 20px;
        z-index: 100;
        position: absolute;
        box-shadow: 0 0 10px rgba(0,0,0,.1);
        .pop-item{
            height: 30px;
            width: 120px;
            color: #666;
            border-radius: 10px;
            font-size: 14px;
            cursor: pointer;
        }

    }
   

    .selectStyle{
        background: red;
    }
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        float: left; width: 50%;height: 100%
    }
    .header{
        margin: auto;
        width: 90%;
        height: 65px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
        display: flex;
        align-items: center;
    }
    .company-name{
        width: 187px;
        height: 30px;
        /* margin-top: 10px; */
        /* border: 1px solid red; */
    }

    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>